/**
 * Mouse's base URL comes from Connect's per-environment config
 * (`src/config/config.*.ts`, `url.mouse`), the same place as every other
 * backend: no environment-variable override, because Connect has none for
 * Zion, Trinity or Trunk either. Trailing slashes are stripped so
 * `base + '/org/ordering'` never doubles up.
 */
export function resolveMouseBaseUrl(configUrl: string): string {
  return configUrl.trim().replace(/\/+$/, '')
}
